/**
 * @generated SignedSource<<1451702ecad23462e6bc64881a7b8625>>
 * @relayHash 8df7adabc51bb38c03296a37df5bdd3f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID eb45f1b003742727b2be6d8636ab4b50248a4ad9a5a398b3c8703b2c52f169e6

import type { ConcreteRequest } from 'relay-runtime';
export type useIncomingLinksQuery$variables = {
  after?: string | null;
  cypherQuery: string;
  first?: number | null;
};
export type useIncomingLinksQuery$data = {
  readonly graphStore_cypherQueryV2: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string | null;
      readonly node: {
        readonly columns: ReadonlyArray<{
          readonly key: string;
          readonly value: {
            readonly data?: {
              readonly __typename: "BitbucketRepository";
              readonly BitbucketRepository_href: AGG$URL | null;
            } | {
              readonly __typename: "CompassComponent";
              readonly CompassComponent_url: string | null;
            } | {
              readonly __typename: "ConfluenceBlogPost";
              readonly ConfluenceBlogPost_links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "ConfluenceDatabase";
              readonly ConfluenceDatabase_links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "ConfluenceEmbed";
              readonly ConfluenceEmbed_links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "ConfluenceFolder";
              readonly ConfluenceFolder_links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "ConfluenceFooterComment";
              readonly ConfluenceFooterComment_links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "ConfluenceInlineComment";
              readonly ConfluenceInlineComment_links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "ConfluencePage";
              readonly ConfluencePage_links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "ConfluenceSlide";
              readonly ConfluenceSlide_links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "ConfluenceSpace";
              readonly ConfluenceSpace_links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "ConfluenceWhiteboard";
              readonly ConfluenceWhiteboard_links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "DeploymentSummary";
              readonly DeploymentSummary_url: string | null;
            } | {
              readonly __typename: "DevOpsDesign";
              readonly DevOpsDesign_url: AGG$URL | null;
            } | {
              readonly __typename: "DevOpsDocument";
              readonly DevOpsDocument_url: AGG$URL | null;
            } | {
              readonly __typename: "DevOpsOperationsIncidentDetails";
              readonly DevOpsOperationsIncidentDetails_url: string | null;
            } | {
              readonly __typename: "DevOpsOperationsPostIncidentReviewDetails";
              readonly DevOpsOperationsPostIncidentReviewDetails_url: string | null;
            } | {
              readonly __typename: "DevOpsProjectDetails";
              readonly DevOpsProjectDetails_url: AGG$URL;
            } | {
              readonly __typename: "DevOpsPullRequestDetails";
              readonly DevOpsPullRequestDetails_url: string | null;
            } | {
              readonly __typename: "DevOpsRepository";
              readonly DevOpsRepository_url: AGG$URL | null;
            } | {
              readonly __typename: "DevOpsSecurityVulnerabilityDetails";
              readonly DevOpsSecurityVulnerabilityDetails_url: string | null;
            } | {
              readonly __typename: "ExternalBranch";
              readonly ExternalBranch_url: string | null;
            } | {
              readonly __typename: "ExternalBuildInfo";
              readonly ExternalBuildInfo_url: string | null;
            } | {
              readonly __typename: "ExternalCalendarEvent";
              readonly ExternalCalendarEvent_url: string | null;
            } | {
              readonly __typename: "ExternalComment";
              readonly ExternalComment_url: string | null;
            } | {
              readonly __typename: "ExternalCommit";
              readonly ExternalCommit_url: string | null;
            } | {
              readonly __typename: "ExternalConversation";
              readonly ExternalConversation_url: string | null;
            } | {
              readonly __typename: "ExternalDashboard";
              readonly ExternalDashboard_url: string | null;
            } | {
              readonly __typename: "ExternalDataTable";
              readonly ExternalDataTable_url: string | null;
            } | {
              readonly __typename: "ExternalDeal";
              readonly ExternalDeal_url: string | null;
            } | {
              readonly __typename: "ExternalDeployment";
              readonly ExternalDeployment_url: string | null;
            } | {
              readonly __typename: "ExternalDesign";
              readonly ExternalDesign_url: string | null;
            } | {
              readonly __typename: "ExternalDocument";
              readonly ExternalDocument_url: string | null;
            } | {
              readonly __typename: "ExternalMessage";
              readonly ExternalMessage_url: string | null;
            } | {
              readonly __typename: "ExternalPullRequest";
              readonly ExternalPullRequest_url: string | null;
            } | {
              readonly __typename: "ExternalRemoteLink";
              readonly ExternalRemoteLink_url: string | null;
            } | {
              readonly __typename: "ExternalRepository";
              readonly ExternalRepository_url: string | null;
            } | {
              readonly __typename: "ExternalSoftwareService";
              readonly ExternalSoftwareService_url: string | null;
            } | {
              readonly __typename: "ExternalSpace";
              readonly ExternalSpace_url: string | null;
            } | {
              readonly __typename: "ExternalTest";
              readonly ExternalTest_url: string | null;
            } | {
              readonly __typename: "ExternalVideo";
              readonly ExternalVideo_url: string | null;
            } | {
              readonly __typename: "ExternalVulnerability";
              readonly ExternalVulnerability_url: string | null;
            } | {
              readonly __typename: "ExternalWorkItem";
              readonly ExternalWorkItem_url: string | null;
            } | {
              readonly __typename: "JiraIssue";
              readonly JiraIssue_webUrl: AGG$URL | null;
            } | {
              readonly __typename: "JiraPlatformComment";
              readonly JiraPlatformComment_webUrl: AGG$URL | null;
            } | {
              readonly __typename: "JiraProject";
              readonly JiraProject_webUrl: AGG$URL | null;
            } | {
              readonly __typename: "JiraServiceManagementComment";
              readonly JiraServiceManagementComment_webUrl: AGG$URL | null;
            } | {
              readonly __typename: "LoomComment";
              readonly LoomComment_url: string | null;
            } | {
              readonly __typename: "LoomSpace";
              readonly LoomSpace_url: string;
            } | {
              readonly __typename: "LoomVideo";
              readonly LoomVideo_url: string;
            } | {
              readonly __typename: "MercuryAsk";
              readonly MercuryAsk_url: AGG$URL | null;
            } | {
              readonly __typename: "MercuryFocusArea";
              readonly MercuryFocusArea_url: string | null;
            } | {
              readonly __typename: "TownsquareComment";
              readonly TownsquareComment_url: string | null;
            } | {
              readonly __typename: "TownsquareGoal";
              readonly TownsquareGoal_url: string | null;
            } | {
              readonly __typename: "TownsquareGoalUpdate";
              readonly TownsquareGoalUpdate_url: string | null;
            } | {
              readonly __typename: "TownsquareProject";
              readonly TownsquareProject_url: string | null;
            } | {
              readonly __typename: "TownsquareProjectUpdate";
              readonly TownsquareProjectUpdate_url: string | null;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            } | null;
          } | null;
        }>;
      };
    }>;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    };
  } | null;
};
export type useIncomingLinksQuery = {
  response: useIncomingLinksQuery$data;
  variables: useIncomingLinksQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cypherQuery"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "cypherQuery"
  }
],
v4 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v6 = {
  "kind": "ScalarField",
  "name": "key"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
],
v9 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ConfluenceBlogPost_links",
      "concreteType": "ConfluenceBlogPostLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v8/*: any*/)
    }
  ],
  "type": "ConfluenceBlogPost"
},
v10 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ConfluenceDatabase_links",
      "concreteType": "ConfluenceDatabaseLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v8/*: any*/)
    }
  ],
  "type": "ConfluenceDatabase"
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ConfluenceEmbed_links",
      "concreteType": "ConfluenceEmbedLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v8/*: any*/)
    }
  ],
  "type": "ConfluenceEmbed"
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ConfluenceFolder_links",
      "concreteType": "ConfluenceFolderLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v8/*: any*/)
    }
  ],
  "type": "ConfluenceFolder"
},
v13 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ConfluenceFooterComment_links",
      "concreteType": "ConfluenceCommentLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v8/*: any*/)
    }
  ],
  "type": "ConfluenceFooterComment"
},
v14 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ConfluenceInlineComment_links",
      "concreteType": "ConfluenceCommentLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v8/*: any*/)
    }
  ],
  "type": "ConfluenceInlineComment"
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ConfluencePage_links",
      "concreteType": "ConfluencePageLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v8/*: any*/)
    }
  ],
  "type": "ConfluencePage"
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ConfluenceSlide_links",
      "concreteType": "ConfluenceSlideLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v8/*: any*/)
    }
  ],
  "type": "ConfluenceSlide"
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ConfluenceSpace_links",
      "concreteType": "ConfluenceSpaceLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v8/*: any*/)
    }
  ],
  "type": "ConfluenceSpace"
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ConfluenceWhiteboard_links",
      "concreteType": "ConfluenceWhiteboardLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v8/*: any*/)
    }
  ],
  "type": "ConfluenceWhiteboard"
},
v19 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "JiraIssue_webUrl",
      "kind": "ScalarField",
      "name": "webUrl"
    }
  ],
  "type": "JiraIssue"
},
v20 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "JiraPlatformComment_webUrl",
      "kind": "ScalarField",
      "name": "webUrl"
    }
  ],
  "type": "JiraPlatformComment"
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "JiraProject_webUrl",
      "kind": "ScalarField",
      "name": "webUrl"
    }
  ],
  "type": "JiraProject"
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "JiraServiceManagementComment_webUrl",
      "kind": "ScalarField",
      "name": "webUrl"
    }
  ],
  "type": "JiraServiceManagementComment"
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "TownsquareComment_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "TownsquareComment"
},
v24 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "TownsquareGoal_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "TownsquareGoal"
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "TownsquareGoalUpdate_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "TownsquareGoalUpdate"
},
v26 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "TownsquareProject_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "TownsquareProject"
},
v27 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "TownsquareProjectUpdate_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "TownsquareProjectUpdate"
},
v28 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "LoomComment_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "LoomComment"
},
v29 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "LoomSpace_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "LoomSpace"
},
v30 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "LoomVideo_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "LoomVideo"
},
v31 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "MercuryAsk_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "MercuryAsk"
},
v32 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "MercuryFocusArea_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "MercuryFocusArea"
},
v33 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "BitbucketRepository_href",
      "kind": "ScalarField",
      "name": "href"
    }
  ],
  "type": "BitbucketRepository"
},
v34 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "DeploymentSummary_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "DeploymentSummary"
},
v35 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "DevOpsDesign_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "DevOpsDesign"
},
v36 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "DevOpsDocument_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "DevOpsDocument"
},
v37 = {
  "alias": "DevOpsOperationsIncidentDetails_url",
  "kind": "ScalarField",
  "name": "url"
},
v38 = {
  "alias": "DevOpsOperationsPostIncidentReviewDetails_url",
  "kind": "ScalarField",
  "name": "url"
},
v39 = {
  "alias": "DevOpsProjectDetails_url",
  "kind": "ScalarField",
  "name": "url"
},
v40 = {
  "alias": "DevOpsPullRequestDetails_url",
  "kind": "ScalarField",
  "name": "url"
},
v41 = {
  "alias": "DevOpsRepository_url",
  "kind": "ScalarField",
  "name": "url"
},
v42 = {
  "alias": "DevOpsSecurityVulnerabilityDetails_url",
  "kind": "ScalarField",
  "name": "url"
},
v43 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "CompassComponent_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "CompassComponent"
},
v44 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ExternalBranch_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalBranch"
},
v45 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ExternalBuildInfo_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalBuildInfo"
},
v46 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ExternalCalendarEvent_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalCalendarEvent"
},
v47 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ExternalComment_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalComment"
},
v48 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ExternalCommit_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalCommit"
},
v49 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ExternalConversation_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalConversation"
},
v50 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ExternalDashboard_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalDashboard"
},
v51 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ExternalDataTable_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalDataTable"
},
v52 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ExternalDeal_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalDeal"
},
v53 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ExternalDeployment_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalDeployment"
},
v54 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ExternalDesign_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalDesign"
},
v55 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ExternalDocument_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalDocument"
},
v56 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ExternalMessage_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalMessage"
},
v57 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ExternalPullRequest_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalPullRequest"
},
v58 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ExternalRemoteLink_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalRemoteLink"
},
v59 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ExternalRepository_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalRepository"
},
v60 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ExternalSoftwareService_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalSoftwareService"
},
v61 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ExternalSpace_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalSpace"
},
v62 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ExternalTest_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalTest"
},
v63 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ExternalVideo_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalVideo"
},
v64 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ExternalVulnerability_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalVulnerability"
},
v65 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ExternalWorkItem_url",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalWorkItem"
},
v66 = {
  "kind": "ScalarField",
  "name": "id"
},
v67 = [
  (v66/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useIncomingLinksQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "GraphStoreCypherQueryV2Connection",
        "kind": "LinkedField",
        "name": "graphStore_cypherQueryV2",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "concreteType": "GraphStoreCypherQueryV2Edge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "concreteType": "GraphStoreCypherQueryV2Node",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreCypherQueryV2Column",
                    "kind": "LinkedField",
                    "name": "columns",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v13/*: any*/),
                                  (v14/*: any*/),
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v29/*: any*/),
                                  (v30/*: any*/),
                                  (v31/*: any*/),
                                  (v32/*: any*/),
                                  (v33/*: any*/),
                                  (v34/*: any*/),
                                  (v35/*: any*/),
                                  (v36/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v37/*: any*/)
                                    ],
                                    "type": "DevOpsOperationsIncidentDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v38/*: any*/)
                                    ],
                                    "type": "DevOpsOperationsPostIncidentReviewDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v39/*: any*/)
                                    ],
                                    "type": "DevOpsProjectDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v40/*: any*/)
                                    ],
                                    "type": "DevOpsPullRequestDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v41/*: any*/)
                                    ],
                                    "type": "DevOpsRepository"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v42/*: any*/)
                                    ],
                                    "type": "DevOpsSecurityVulnerabilityDetails"
                                  },
                                  (v43/*: any*/),
                                  (v44/*: any*/),
                                  (v45/*: any*/),
                                  (v46/*: any*/),
                                  (v47/*: any*/),
                                  (v48/*: any*/),
                                  (v49/*: any*/),
                                  (v50/*: any*/),
                                  (v51/*: any*/),
                                  (v52/*: any*/),
                                  (v53/*: any*/),
                                  (v54/*: any*/),
                                  (v55/*: any*/),
                                  (v56/*: any*/),
                                  (v57/*: any*/),
                                  (v58/*: any*/),
                                  (v59/*: any*/),
                                  (v60/*: any*/),
                                  (v61/*: any*/),
                                  (v62/*: any*/),
                                  (v63/*: any*/),
                                  (v64/*: any*/),
                                  (v65/*: any*/)
                                ]
                              }
                            ],
                            "type": "GraphStoreCypherQueryV2AriNode"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useIncomingLinksQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "GraphStoreCypherQueryV2Connection",
        "kind": "LinkedField",
        "name": "graphStore_cypherQueryV2",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "concreteType": "GraphStoreCypherQueryV2Edge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "concreteType": "GraphStoreCypherQueryV2Node",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreCypherQueryV2Column",
                    "kind": "LinkedField",
                    "name": "columns",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isGraphStoreCypherQueryV2AriNodeUnion"
                                  },
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v13/*: any*/),
                                  (v14/*: any*/),
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v29/*: any*/),
                                  (v30/*: any*/),
                                  (v31/*: any*/),
                                  (v32/*: any*/),
                                  (v33/*: any*/),
                                  (v34/*: any*/),
                                  (v35/*: any*/),
                                  (v36/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v37/*: any*/),
                                      (v66/*: any*/)
                                    ],
                                    "type": "DevOpsOperationsIncidentDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v38/*: any*/),
                                      (v66/*: any*/)
                                    ],
                                    "type": "DevOpsOperationsPostIncidentReviewDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v39/*: any*/),
                                      (v66/*: any*/)
                                    ],
                                    "type": "DevOpsProjectDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v40/*: any*/),
                                      (v66/*: any*/)
                                    ],
                                    "type": "DevOpsPullRequestDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v41/*: any*/),
                                      (v66/*: any*/)
                                    ],
                                    "type": "DevOpsRepository"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v42/*: any*/),
                                      (v66/*: any*/)
                                    ],
                                    "type": "DevOpsSecurityVulnerabilityDetails"
                                  },
                                  (v43/*: any*/),
                                  (v44/*: any*/),
                                  (v45/*: any*/),
                                  (v46/*: any*/),
                                  (v47/*: any*/),
                                  (v48/*: any*/),
                                  (v49/*: any*/),
                                  (v50/*: any*/),
                                  (v51/*: any*/),
                                  (v52/*: any*/),
                                  (v53/*: any*/),
                                  (v54/*: any*/),
                                  (v55/*: any*/),
                                  (v56/*: any*/),
                                  (v57/*: any*/),
                                  (v58/*: any*/),
                                  (v59/*: any*/),
                                  (v60/*: any*/),
                                  (v61/*: any*/),
                                  (v62/*: any*/),
                                  (v63/*: any*/),
                                  (v64/*: any*/),
                                  (v65/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v67/*: any*/),
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v67/*: any*/),
                                    "type": "AppUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v67/*: any*/),
                                    "type": "AtlassianAccountUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v67/*: any*/),
                                    "type": "CustomerUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v67/*: any*/),
                                    "type": "DevOpsFeatureFlag"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v67/*: any*/),
                                    "type": "DevOpsOperationsComponentDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v67/*: any*/),
                                    "type": "JiraAutodevJob"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v67/*: any*/),
                                    "type": "JiraConfluenceRemoteIssueLink"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v67/*: any*/),
                                    "type": "JiraCustomRemoteIssueLink"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v67/*: any*/),
                                    "type": "JiraIssueRemoteIssueLink"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v67/*: any*/),
                                    "type": "JiraWebRemoteIssueLink"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v67/*: any*/),
                                    "type": "TeamCustomFieldValue"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v67/*: any*/),
                                    "type": "TeamType"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v67/*: any*/),
                                    "type": "ThirdPartyUser"
                                  }
                                ]
                              },
                              (v66/*: any*/)
                            ],
                            "type": "GraphStoreCypherQueryV2AriNode"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "8df7adabc51bb38c03296a37df5bdd3f",
    "id": "eb45f1b003742727b2be6d8636ab4b50248a4ad9a5a398b3c8703b2c52f169e6",
    "metadata": {},
    "name": "useIncomingLinksQuery",
    "operationKind": "query",
    "text": "query useIncomingLinksQuery($cypherQuery:String!,$first:Int,$after:String){graphStore_cypherQueryV2(query:$cypherQuery,first:$first,after:$after)@optIn(to:\"GraphStoreCypherQueryV2\"){pageInfo{hasNextPage,endCursor},edges{cursor,node{columns{key,value{__typename,...on GraphStoreCypherQueryV2AriNode{data{__typename,__isGraphStoreCypherQueryV2AriNodeUnion:__typename,...on ConfluenceBlogPost{ConfluenceBlogPost_links:links{base,webUi}},...on ConfluenceDatabase{ConfluenceDatabase_links:links{base,webUi}},...on ConfluenceEmbed{ConfluenceEmbed_links:links{base,webUi}},...on ConfluenceFolder{ConfluenceFolder_links:links{base,webUi}},...on ConfluenceFooterComment{ConfluenceFooterComment_links:links{base,webUi}},...on ConfluenceInlineComment{ConfluenceInlineComment_links:links{base,webUi}},...on ConfluencePage{ConfluencePage_links:links{base,webUi}},...on ConfluenceSlide{ConfluenceSlide_links:links{base,webUi}},...on ConfluenceSpace{ConfluenceSpace_links:links{base,webUi}},...on ConfluenceWhiteboard{ConfluenceWhiteboard_links:links{base,webUi}},...on JiraIssue{JiraIssue_webUrl:webUrl},...on JiraPlatformComment{JiraPlatformComment_webUrl:webUrl},...on JiraProject{JiraProject_webUrl:webUrl},...on JiraServiceManagementComment{JiraServiceManagementComment_webUrl:webUrl},...on TownsquareComment{TownsquareComment_url:url},...on TownsquareGoal{TownsquareGoal_url:url},...on TownsquareGoalUpdate{TownsquareGoalUpdate_url:url},...on TownsquareProject{TownsquareProject_url:url},...on TownsquareProjectUpdate{TownsquareProjectUpdate_url:url},...on LoomComment{LoomComment_url:url},...on LoomSpace{LoomSpace_url:url},...on LoomVideo{LoomVideo_url:url},...on MercuryAsk{MercuryAsk_url:url},...on MercuryFocusArea{MercuryFocusArea_url:url},...on BitbucketRepository{BitbucketRepository_href:href},...on DeploymentSummary{DeploymentSummary_url:url},...on DevOpsDesign{DevOpsDesign_url:url},...on DevOpsDocument{DevOpsDocument_url:url},...on DevOpsOperationsIncidentDetails{DevOpsOperationsIncidentDetails_url:url,id},...on DevOpsOperationsPostIncidentReviewDetails{DevOpsOperationsPostIncidentReviewDetails_url:url,id},...on DevOpsProjectDetails{DevOpsProjectDetails_url:url,id},...on DevOpsPullRequestDetails{DevOpsPullRequestDetails_url:url,id},...on DevOpsRepository{DevOpsRepository_url:url,id},...on DevOpsSecurityVulnerabilityDetails{DevOpsSecurityVulnerabilityDetails_url:url,id},...on CompassComponent{CompassComponent_url:url},...on ExternalBranch{ExternalBranch_url:url},...on ExternalBuildInfo{ExternalBuildInfo_url:url},...on ExternalCalendarEvent{ExternalCalendarEvent_url:url},...on ExternalComment{ExternalComment_url:url},...on ExternalCommit{ExternalCommit_url:url},...on ExternalConversation{ExternalConversation_url:url},...on ExternalDashboard{ExternalDashboard_url:url},...on ExternalDataTable{ExternalDataTable_url:url},...on ExternalDeal{ExternalDeal_url:url},...on ExternalDeployment{ExternalDeployment_url:url},...on ExternalDesign{ExternalDesign_url:url},...on ExternalDocument{ExternalDocument_url:url},...on ExternalMessage{ExternalMessage_url:url},...on ExternalPullRequest{ExternalPullRequest_url:url},...on ExternalRemoteLink{ExternalRemoteLink_url:url},...on ExternalRepository{ExternalRepository_url:url},...on ExternalSoftwareService{ExternalSoftwareService_url:url},...on ExternalSpace{ExternalSpace_url:url},...on ExternalTest{ExternalTest_url:url},...on ExternalVideo{ExternalVideo_url:url},...on ExternalVulnerability{ExternalVulnerability_url:url},...on ExternalWorkItem{ExternalWorkItem_url:url},...on Node{__isNode:__typename,id},...on AppUser{id},...on AtlassianAccountUser{id},...on CustomerUser{id},...on DevOpsFeatureFlag{id},...on DevOpsOperationsComponentDetails{id},...on JiraAutodevJob{id},...on JiraConfluenceRemoteIssueLink{id},...on JiraCustomRemoteIssueLink{id},...on JiraIssueRemoteIssueLink{id},...on JiraWebRemoteIssueLink{id},...on TeamCustomFieldValue{id},...on TeamType{id},...on ThirdPartyUser{id}},id}}}}}}}"
  }
};
})();

(node as any).hash = "56481ab26b9cdb10fdd54e061bdba4d2";

export default node;
